export default __webpack_public_path__ + "static/media/project1.6c3e0a79.jpg";